export default __webpack_public_path__ + "static/media/ja2.fa964a6b.jpg";